/* eslint-disable no-shadow */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  EventDetailsContainer,
} from '@resy/ui-kitchen';

import WidgetNav from '../WidgetNav';
import { getURLSearchParams } from '../../../../../ui-kitchen/src/utils/searchParamUtils';
import { useRouteParams } from '../../utils/legacyUtils';
import { setPreviewMode } from '../../../../../ui-kitchen/src/reducers/resyRouterSlice';
import './EventPage.scss';
import { GatingMessageModal } from '../../../../../ui-kitchen/src/components/Gating/GatingMessageModal';

const EventPage = ({
  Analytics,
  context,
  onTicketQuantitySelect,
  matchMedia,
  notifyService,
  resyToken,
  seats,
  selectResy,
  setPreviewMode,
  tableConfigId,
  userIsGda,
  displayGatingErrorModal,
  ResyAmexConfig,
  closeModal,
}) => {
  const searchParams = getURLSearchParams();
  const $routeParamsShim = useRouteParams();
  const previewModeParam = searchParams.get('previewMode');
  let previewMode = false;
  if (previewModeParam !== null) {
    previewMode = !!previewModeParam;
    setPreviewMode(previewMode);
  }
  const $rootScopeEventDetailsShim = {
    $broadcast: () => {},
    $digest: () => {},
    matchMedia,
    metadata: {},
    previewMode,
  };
  const navigate = useNavigate();

  return (
    <div className="EventPage">
      <WidgetNav
        invert
        navigate={navigate}
        showProfileMenu
        titleOpacity={0}
        Analytics={Analytics}
      />
      <EventDetailsContainer
        $rootScope={$rootScopeEventDetailsShim}
        $routeParams={$routeParamsShim}
        Analytics={Analytics}
        context={context}
        notifyService={notifyService}
        onTicketQuantitySelect={onTicketQuantitySelect}
        resyToken={resyToken}
        seats={seats}
        selectResy={selectResy}
        tableConfigId={tableConfigId}
        userIsGda={userIsGda}
      />
      {displayGatingErrorModal && (
        <GatingMessageModal
          Analytics={Analytics}
          closeModal={closeModal}
          ResyAmexConfig={ResyAmexConfig}
        />
      )}
    </div>
  );
};

const eventPagePropTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  context: PropTypes.string,
  matchMedia: PropTypes.shape({}).isRequired,
  notifyService: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  onTicketQuantitySelect: PropTypes.func.isRequired,
  resyToken: PropTypes.string,
  seats: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  selectResy: PropTypes.func.isRequired,
  setPreviewMode: PropTypes.func.isRequired,
  tableConfigId: PropTypes.string,
  userIsGda: PropTypes.bool,
  displayGatingErrorModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  ResyAmexConfig: PropTypes.shape({
    baseRequestUrl: PropTypes.string.isRequired,
  }).isRequired,
};

EventPage.propTypes = eventPagePropTypes;

EventPage.defaultProps = {
  context: 'widget',
  notifyService: undefined,
  resyToken: undefined,
  seats: undefined,
  tableConfigId: undefined,
  userIsGda: false,
};

const mapStateToProps = ({ matchMedia }) => ({
  matchMedia,
});

const mapDispatchToProps = {
  setPreviewMode,
};

export { eventPagePropTypes, EventPage as ComponentUnderTest };
export default connect(mapStateToProps, mapDispatchToProps)(EventPage);
